export const LOGO = "/aikyam-logo.png";
export const CONTACT_EMAIL = "madhavanaikyamwealth@gmail.com";

// Add the founder's Calendly / booking link here when available.
// If empty, the "Book a discovery call" button falls back to an email link.
export const BOOKING_URL = "";

export const FOUNDER = {
  name: "Madhavan Natarajan",
  title: "Founder & Director, Aikyam Strategic Management Services · TAB Business Owner, Puducherry",
  photo: "/madhavan.webp",
  bio:
    "A Chartered Market Technician and Behavioural Finance practitioner with over three decades of " +
    "experience across financial markets, wealth structuring, business advisory and enterprise transformation. " +
    "Using his proprietary Family Business 360 framework, Madhavan helps SME and family-business owners align vision, " +
    "strategy and execution — strengthening governance, decision-making and leadership-driven performance. " +
    "His advisory spans manufacturing, retail, food, construction and financial services.",
};
